import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "../adminApi";

const FIELDS = [
  { key: "company_name", label: "Company Name" },
  { key: "email", label: "Email Address" },
  { key: "phone", label: "Phone Number" },
  { key: "office_address", label: "Office Address" },
  { key: "business_hours", label: "Business Hours" },
  { key: "linkedin_url", label: "LinkedIn URL" },
];

const FIELD = "w-full rounded-lg border border-[#E5E7EB] px-4 py-2.5 text-sm text-[#1F2937] focus:outline-none focus:border-[#1E88E5] focus:ring-2 focus:ring-[#1E88E5]/20 transition";

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/settings").then(({ data }) => setSettings(data));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put("/admin/settings", settings);
      toast.success("Settings saved — changes are live on the website.");
    } catch {
      toast.error("Failed to save settings.");
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return <div className="flex items-center gap-2 text-[#4B5563]"><Loader2 className="animate-spin" size={18} /> Loading…</div>;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="admin-settings">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#0A2342]">Settings</h1>
        <p className="text-sm text-[#4B5563] mt-1">Company and contact information shown across the website.</p>
      </div>
      <div className="bg-white rounded-xl border border-[#E5E7EB] p-6 space-y-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <label className="block text-sm font-semibold text-[#0A2342] mb-1.5">{f.label}</label>
            <input data-testid={`setting-${f.key}`} className={FIELD} value={settings[f.key] || ""} onChange={(e) => setSettings((s) => ({ ...s, [f.key]: e.target.value }))} />
          </div>
        ))}
      </div>
      <button data-testid="settings-save" onClick={save} disabled={saving} className="inline-flex items-center gap-2 rounded-lg bg-[#0A2342] text-white px-6 py-3 font-semibold hover:bg-[#1E88E5] transition-colors disabled:opacity-60">
        {saving ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />} Save Changes
      </button>
    </div>
  );
}
